import { useField } from "react-final-form";
import { Box } from "@material-ui/core";
import useConditions from "../../../hooks/useConditions";
const TierConditionFixedField = () => {
  const { getLTVConditionId, loading, error } = useConditions();
  const {
    input: { onChange },
  } = useField("tier_condition_id");

  if (loading) return null;
  if (error) return null;

  onChange(getLTVConditionId());
  return <Box></Box>;
};

export default TierConditionFixedField;
